/**
 * 유효성 검사 오류 타입 정의
 */
export interface ValidationError {
  hasError: boolean;
  message: string;
}

/**
 * 이메일 유효성 검사
 * @param email 검사할 이메일 주소
 * @returns ValidationError 객체
 */
export const validateEmail = (email: string): ValidationError => {
  if (!email.trim()) {
    return {
      hasError: true,
      message: '이메일을 입력해주세요.',
    };
  }

  // 이메일 형식 검사를 위한 정규식
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return {
      hasError: true,
      message: '유효한 이메일 주소를 입력해주세요.',
    };
  }

  return {
    hasError: false,
    message: '',
  };
};

/**
 * 비밀번호 유효성 검사
 * @param password 검사할 비밀번호
 * @returns ValidationError 객체
 */
export const validatePassword = (password: string): ValidationError => {
  if (!password) {
    return {
      hasError: true,
      message: '비밀번호를 입력해주세요.',
    };
  }

  if (password.length < 8) {
    return {
      hasError: true,
      message: '비밀번호는 최소 8자 이상이어야 합니다.',
    };
  }

  return {
    hasError: false,
    message: '',
  };
};

/**
 * 이름 유효성 검사
 * @param name 검사할 이름
 * @returns ValidationError 객체
 */
export const validateName = (name: string): ValidationError => {
  if (!name.trim()) {
    return {
      hasError: true,
      message: '이름을 입력해주세요.',
    };
  }

  return {
    hasError: false,
    message: '',
  };
};

/**
 * 비밀번호 확인 유효성 검사
 * @param password 입력한 비밀번호
 * @param confirmPassword 확인용 비밀번호
 * @returns ValidationError 객체
 */
export const validateConfirmPassword = (
  password: string,
  confirmPassword: string,
): ValidationError => {
  if (!confirmPassword) {
    return {
      hasError: true,
      message: '비밀번호 확인을 입력해주세요.',
    };
  }

  if (password !== confirmPassword) {
    return {
      hasError: true,
      message: '비밀번호가 일치하지 않습니다.',
    };
  }

  return {
    hasError: false,
    message: '',
  };
};
